export enum LoanCreationType {
  NEW_LOAN = 'NEW_LOAN',
  ADDITIONAL_LOAN = 'ADDITIONAL_LOAN',
  RELOAN = 'RELOAN',
  CONSOLIDATION = 'CONSOLIDATION',
  EXTENSION = 'EXTENSION',
  RENEWAL = 'RENEWAL'
}
